import React from 'react';
import Button from '../Components/Button';
import {HAPPY_PAY_PUBLIC, LOGIN_CLOSED} from '../config/campaign';

const Navigate = ({toggle}) => {
    return (
        <div
            className='flex justify-between items-center w-full h-24 bg-white text-[#0987F3] px-40 font-medium mobile:px-4 laptop:px-20'>
            <a className='flex justify-start items-center w-52' href="/"><img className='w-40'
                                                                              src="/images/TDB_loyalty.png"/></a>
            <div className='hidden mobile:block' onClick={toggle}><p className='text-base hidden mobile:block'>MENU</p>
            </div>
            <Button
                style="hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 p-3 rounded-lg cursor-pointer tablet:text-sm mobile:hidden"
                link={"/infosaving"} name={"Хуримтлалтай Монгол"} name2={"Хадгаламжийн урамшуулалт аян"}/>
            {/*<Button*/}
            {/*    style="hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 p-3 rounded-lg cursor-pointer tablet:text-sm mobile:hidden"*/}
            {/*    link={"/infovisa"} name={"HAPPY PAY"} name2={"Картын урамшуулалт хөтөлбөр"}/>*/}
            {/*<Button*/}
            {/*    style="hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 p-3 rounded-lg cursor-pointer tablet:text-sm mobile:hidden"*/}
            {/*    link={"/infomerchant"} name={"HAPPY MERCHANT"} name2={"Жижиг дунд бизнесийн урамшуулалт хөтөлбөр"}/>*/}
            {/*<Button*/}
            {/*    style="hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 p-3 rounded-lg cursor-pointer tablet:text-sm mobile:hidden"*/}
            {/*    link={"/infoapple"} name={"APPLE PAY"} name2={"Apple pay-н урамшуулалт хөтөлбөр"}/>*/}
            {HAPPY_PAY_PUBLIC && <Button
                style="hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 p-3 rounded-lg cursor-pointer tablet:text-sm mobile:hidden"
                link={"/infohappy"} name={"HAPPY PAY"} name2={"Happy pay-н урамшуулалт хөтөлбөр"}/>}

            {/* The w-52 box stays even while login is closed so justify-between keeps the layout. */}
            <div className='w-52 flex justify-end items-center mobile:hidden'>
                {!LOGIN_CLOSED && <Button
                    style="rounded-lg w-36 h-8 font-semibold text-white text-sm bottom-[30px] bg-[#0987F3] hover:text-white"
                    link={'/login'} name={'Нэвтрэх'}/>}
            </div>
        </div>
    );
}

export default Navigate;